import { ScoreStatus as ScoreStatusGQL } from '$extensionSrc/__generated__/graphql'

export type ScoreStatus = 'Minimal' | 'Moderate' | 'High'
export type StatusDotColor = 'red' | 'yellow' | 'green'

export const ScoreStatuses: ScoreStatus[] = ['Minimal', 'Moderate', 'High']

export function getStatusDotColorForStatus(
  status: ScoreStatus,
): StatusDotColor {
  switch (status) {
    case 'Minimal':
      return 'red'
    case 'Moderate':
      return 'yellow'
    case 'High':
      return 'green'
    default:
      return 'red'
  }
}

export function convertScoreStatusGQLToScoreStatus(
  status: ScoreStatusGQL | null,
): ScoreStatus | null {
  switch (status) {
    case null:
      return null
    case ScoreStatusGQL.Minimal:
      return 'Minimal'
    case ScoreStatusGQL.Moderate:
      return 'Moderate'
    case ScoreStatusGQL.High:
      return 'High'
    default:
      return null
  }
}
